<template>
    <div class="layout">
        <div class="layout__header">
            <h3>Comprobantes</h3>
        </div>
        <div class="row">
            <div class="col-xs-12 col-md-4">
                <div class="form-field">
                    <div class="form-group">
                        <input-field v-model="form.id_persona" id="filtroPersona" placeholder="Consulte una persona...">
                            Persona
                        </input-field>
                    </div>
                </div>
            </div>
            <div v-show="tipoComprobante !== '07' && tipoComprobante !== '04'" class="col-xs-12 col-md-4">
                <div class="form-field">
                    <input-field v-model="form.selectedVendedor" id="selectedVendedor" placeholder="Consulte un vendedor...">
                        Vendedor
                    </input-field>
                </div>
            </div>
            <div class="col-xs-12 col-md-4">
                <div class="form-field">
                    <input-field v-model="form.selectedItem" id="selectedItem" placeholder="Consulte un ítem...">
                        Ítem
                    </input-field>
                </div>
            </div>
            <div v-show="tipoComprobante === '00'" class="col-xs-12 col-md-6">
                <div class="form-field">
                    <input-field v-model="form.observacion" id="observacionLista" placeholder="Consulte la observación...">
                        Observación
                    </input-field>
                </div>
            </div>
            <div class="col-xs-12 col-md-4">
                <div class="form-field">
                    <label v-show="tipoComprobante === '01' || tipoComprobante === '99'" for="impagos">
                        <input @change="$refs.tablaComprobantes.loadRows()" type="checkbox" id="impagos" v-model="form.impagos"> <span>Ver comprobantes impagos</span>
                    </label>
                </div>
            </div>
        </div>
        <div class="mt-3">
            <k-table ref="tablaComprobantes" 
                @ver="ver"
                :tipoComprobante="tipoComprobante"
                :createButton="false" 
                :esComprobante="true" 
                :filterStatus="false" 
                :editButton="false" 
                :deleteButton="false" 
                @seleccionar="seleccionar" 
                :path="path" 
                :params="form"
                :buttons="tipoComprobante !== '99'?[
                    {
                        text : '',
                        class : 'btn-info',
                        icon : 'fa-eye',
                        event : 'ver'
                    }
                ]:[]"
                :columns="[
                {
                    display : 'Fecha de emisión',
                    value : 'fecha_emision_comprobante'
                },
                {
                    display : 'N° establecimiento',
                    value : 'codigo_establecimiento',
                    hidden : tipoComprobante === '00'
                },
                {
                    display : 'N° emisor',
                    value : 'codigo_emisor',
                    hidden : tipoComprobante === '00'
                },
                {
                    display : 'N° Secuencial',
                    value : 'numero_secuencial'
                },
                {
                    display : 'Vendedor',
                    value : 'nombre_vendedor',
                },
                {
                    display : 'Cliente',
                    value : 'nombre_cliente',
                },
                {
                    display : 'Concepto',
                    value : 'concepto',
                },
                {
                    display : 'N° Identificación del cliente',
                    value : 'numero_identificacion',
                    hidden : tipoComprobante === '00'
                },
                {
                    display : 'Estado de pago',
                    value : 'descripcion_comprobante_pagado',
                    hidden : tipoComprobante !== '01'
                },
                {
                    display : 'Total sin impuestos',
                    value : 'total_sin_impuestos',
                    numeric : true,
                    hidden : tipoComprobante === '07'
                },
                {
                    display : 'IVA',
                    value : 'valor_iva',
                    numeric : true,
                    hidden : tipoComprobante === '07' || true
                },
                {
                    display : 'Total',
                    value : 'valor_total',
                    numeric : true
                },
                {
                    display : 'Facturada',
                    value : 'facturada',
                    hidden : tipoComprobante !== '00'
                },
                {
                    display : 'Estado',
                    value : 'estado'
                }
            ]"></k-table>
        </div>
        <modal width="55%" height="auto" name="consultaPersonas" scrollable>
            <lista-personas :createButton="false" :tipoFiltro="tipoComprobante === '07'?'P':'C'" :filterStatus="false" @selected="selectedPersona"></lista-personas>
        </modal>
    </div>
</template>

<script>
export default {
    props : {
        tipoComprobante : {
            type : String,
            default : '01',
            required : false
        },
        vendedores : {
            type : Array,
            default : function () {
                return [];
            },
            required : false
        },
    },
    data : function () {
        return {
                comprobantes : [],
                form : {
                    tipo_comprobante : this.tipoComprobante,
                    id_persona : '',
                    impagos : false,
                    selectedVendedor : [],
                    selectedItem : []
                },
                path : url + '/comprobantes/search',
                url : url,
                nombrePersona: ''
        }
        
    },
    methods : {  
        ver : function (comprobante) {
            if (this.tipoComprobante !== '00')
                window.open(this.url + '/comprobantes?tipo_comprobante=' + this.tipoComprobante + '&id_comprobante=' + comprobante.id_comprobante, '_blank');
            else 
                window.open(this.url + '/comprobantes/' + comprobante.id_comprobante + '/edit', '_blank');
        },  
        seleccionar : function(currentComprobante) {     
            this.$emit('selected', currentComprobante);
        },
        selectedPersona : function (persona) {
            this.nombrePersona = persona.nombre;
            this.form.id_persona = persona.id;
            this.$modal.hide('consultaPersonas');
            this.$refs.tablaComprobantes.loadRows();
        },
        quitarPersona : function () {
            this.nombrePersona = '';
            this.form.id_persona = '';
            this.$refs.tablaComprobantes.loadRows();
        }
    }
}
</script>




// WEBPACK FOOTER //
// resources/assets/js/components/forms/comprobantes/ListaComprobantes.vue